// 透過 @ay-nestjs/share 產生
/* eslint-disable */

export class ServerConfigDto {
  public LOCAL_STORAGE_KEY: string = '';
}
// 7505fd5eacac44ea308164dd87ba96dd9ca873e42e8ed295df9d5babe48e7589
